const rqParams = {
  /**
   * 获取验证码
   */
  getApplyRegist(param) {
    return {
      op_path: 'message.security.applyregist',
      ...param
    }
  },
  /**
   * 验证验证码
   */
  checkMsgCode(param) {
    return {
      op_path: 'message.security.checkmsgcode',
      ...param
    }
  },
  /**
   * 根据密码获取token
   */
  getToken(param) {
    return {
      op_path: 'oauth/token',
      ...param
    }
  },
  /**
   * 根据验证码获取token
   */
  getUserTokenBySmsCode(param) {
    return {
      op_path: 'information.userinfo.getusertokenbysmscode',
      ...param
    }
  },
  /**
   * 登录验证
   */
  loginVerify(param) {
    return {
      op_path: 'information.userinfo.loginverify',
      ...param
    }
  },
  /**
   * 获取微信唯一标识open_id
   */
  getUserOpenid(params) {
    return {
      op_path: 'information.weixinapi.getuseropenidnotoken',
      ...params
    }
  },
  /**
   * 根据微信授权凭据获取我方token信息
   * scope 为snsapi_userinfo
   */
  getTokenByWeChatCode(params) {
    return {
      op_path: 'information.weixinapi.gettokenbywechatcode',
      ...params
    }
  },
  /**
   * 根据open_id获取token
   */
  ifHasBindWeiXinOpenId(params) {
    return {
      op_path: 'information.weixinapi.ifhasbindweixinopenid',
      ...params
    }
  }
}
export default rqParams
